<div class="outer-content">
  <div class="float-left bg-white card-background wh-auto">
  <form [formGroup]="userForm" autocomplete="off" role="form" class="fieldHeight">
    <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='!editMode' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
    <div class="col-md-12 clear-all title-wrapper">
      <h1 class="title-text custom-header-h2 responsive-text-8" id="yourPensionSavings-header">{{contentData.header}}</h1>
    </div>
  <div class="pad-fit-content">
    <div class="col-md-12 clear-all content-wrapper">
      <p class="content-top mt-0" id="yourPensionSavings-introduction">{{contentData.introduction}}</p>
    </div>
    <div class="col-md-12 wrapperMargin content-wrapper">
      <div class="col-md-12 clear-all">
        <div class="col-md-7 clear-all width-66">
          <app-dropdown (onChangeHandler)="ddlChange()" [pageName]="'cedingFund'" 
          [dropdownConfig]="fundProviderConfig" [controlName]="'fundProvider'"
            [parent]="yourPensionForm" [informationRequire]="true" 
            [informationControlName]="'fundProviderInfo'" 
            [informationConfig]="funproviderinformationConfig"
            [ddDisabled]="cameFromMicrosite"
            (onDisplayMobileTooltipEmitter)="displayDrpTooltipMessage()"
            >
          </app-dropdown>
        </div>
      </div>
    </div>
    <div *ngIf="lAndGWarningFlag" class="mob-info-msg">
      <div  class="col-md-12 bg-mr bg-lightblue mar-lr-0">
        <p class="inner-content-data pad-1rem " id="warning_dealpartner">
        {{contentData.legalAndGeneralWarningMessage}}</p>
      </div>
    </div>
    <div *ngIf="slocWarningFlag" class="mob-info-msg">
      <div class="col-md-12 bg-mr bg-lightblue mar-lr-0">
        <p class="inner-content-data" id="warning_dealpartner">
          {{contentData.slocWarningMessage}}</p></div>
    </div>    
    <div *ngIf="aonWarningFlag" class="mob-info-msg">
      <div class="col-md-12 bg-mr bg-lightblue mar-lr-0">
        <p class="inner-content-data pad-1rem " id="warning_dealpartnerAon">
        {{contentData.Aonreferralmessage}}</p></div>
    </div>
    <div class="pad-6">
      <app-question *ngIf="showControl" (toggleChange)='toggleRiskQuestions("guarantees")' [childId]="'guarantees'" [questionConfig]="contentData.guaranteesQuestion"
        [parent]="yourPensionForm" [controlName]="'guarantees'">
      </app-question>

      <app-question *ngIf="showControl" (toggleChange)='toggleRiskQuestions("penalties")' [childId]="'penalties'" [questionConfig]="contentData.penaltiesQuestion"
        [parent]="yourPensionForm" [controlName]="'penalties'">
      </app-question>
    </div>


    <div class="row pad-6" *ngIf="yourPensionForm && yourPensionForm.get('fundProvider').value && validSource">
      <div class="col-md-12 clear-all content-wrapper float-left d-flex">
        <p class="para-font" id="pension-pot-choice">{{contentData.pensionPotChoiceIntroStatement}}
        </p>
        <div class="info-icon d-view left-65">
          <app-tool-tip-notification (totalPensionPotEmitter)="totalPensionPotReceiver($event)" [childId]="'pensionPotChoice'" class="statement-info col-sm-1" [tooltipName]="pensionPotChoiceTooltip"
          [tooltipData]="contentData.pensionPotChoiceInfo">
        </app-tool-tip-notification>
        </div>
        <div class="info-icon mt-view">
          <app-tool-tip-notification (totalPensionPotEmitter)="totalPensionPotReceiver($event)" [childId]="'pensionPotChoice'" class="statement-info col-sm-1" [tooltipName]="pensionPotChoiceTooltip"
          [tooltipData]="contentData.pensionPotChoiceInfo" (onDisplayMobileTooltipEmitter)="displayTooltipMessage()">
        </app-tool-tip-notification>
        </div>
      </div>
    </div>
  </div> <!---newly added-->
    <div class="col-md-12 clear-all content-wrapper">
      <app-pension-source class="pension-source-div" *ngFor="let sourceData of sourcesConfiguration" [sourceConfig]="sourceData.config"
        [parent]="yourPensionForm.get(sourceData.controlName)" [productCodeSelected]="yourPensionForm.get('productCode')" [sourceSelected]="yourPensionForm.get('fundProvider')"
        [parentControlName]="sourceData.controlName" (currencyValueChanged)="updateTotalFund($event)" (productCodeChanged)="validateProductCode($event)"
        (onChangeHandler)="txtChange($event)" (addProductCodeControllerName)="productCodeController($event)" (removeProductCodeControllerName)="RemoveProductCode($event)"
        [minprodCodeLength]="minprodCodeLength" [length]="sourceLength" [pensionFundConfig] = "pensionFundConfig"
        (productCodeEmitter)="productCodeReceiver($event)" (onDisplayMobileTooltipEmitter)="displayTooltipMessageForContract(sourceData.config)">
      </app-pension-source>
      <div id="pensionPotError" class="col-xs-12 form-validation-error" *ngIf="pensionPotErrorValidatorFlag">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p *ngIf="!externalMinInvalid" id="noFund-error">{{contentData.errorMessages.outOfFundErrorMessage}}</p>
        <p *ngIf="externalMinInvalid" id="noFund-error">{{contentData.errorMessages.minFundErrorMessage}}</p>

      </div>
    </div>

    <p class="col-xs-12 total-fund">
      <span class="label" id="totalPension">{{contentData.totalPension}}</span>
      <span class="amount" id="totalFund">{{totalFundAmount | currency :'GBP':'symbol':'1.2-2' }}</span>
    </p>
    <!-- <div *ngIf="!selectedProductAvailable" class="col-md-12 mar-t-30 bg-lightblue">
      <p class="inner-content-data" id="warning_dealpartner">
      {{contentData.isProductAvailable}}</p></div> -->
      

      <div *ngIf="!selectedProductAvailable" class="mob-info-msg"> 
      <div class="col-md-12 bg-mr bg-lightblue margin-top-15 selectedProductAvailable">
        <p class="inner-content-data pad-1rem" id="warning_dealpartner">
        {{contentData.isProductAvailable}}</p></div>
      </div>

    <!-- <div *ngIf="manualSourceSelection">
      <div class="col-md-12 underline margin-top"></div>
      <app-question [childId]="'manualSource'" [questionConfig]="manualSourceConfig" [parent]="yourPensionForm" [controlName]="'manualSource'">
      </app-question>
    </div> -->

    <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>

      <app-modal *ngIf="!displayEditAlert && showModalForCardRefresh" [modalConfig]="alertCardRefreshModalConfig" (closeModal)="closeCardRefreshModal()" (primaryBtnClick)="alertPrimaryBtnClickinModal()"
      (secondaryBtnClick)="alertSecondaryCardRefreshBtnClick()" [saveDataFlag]="false"></app-modal>

    <app-modal *ngIf="displayEditAlert" [modalConfig]="alertModalEditConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
      (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>
      
    <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
      (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>

    <div class="col-md-12 underline margin-top"></div>
    <div class="bottom-container">
      <!-- class="col-md-12 clear-all" -->
      <div class="float-left">
        <app-save [location]="'contentBottom'"></app-save>
      </div>
      <div class="float-right">
        <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'">
        </app-content-bottom-nav>
      </div>
    </div>
  </form>
  </div>
</div>